<template>
  <div class="row format-width">
    <div class="col-12 mb-2">
      <PageTitle title="Relatório Facebook ADS" />  
    </div>

    <div class="col-sm-12 col-md-5 col-lg-5 mt-4">
      <label>Data Início</label>
      <input type="date" class="form-control" v-model="data.dateStart">
    </div>

    <div class="col-sm-12 col-md-5 col-lg-5 mt-4">
      <label>Data Fim</label>
      <input type="date" class="form-control" v-model="data.dateEnd">
    </div>

    <div class="col-sm-12 col-md-2 col-lg-2 mt-4 d-flex flex-column" v-if="whatClerkPermission()">
      <button
        class="btn btn-success btn-block mt-auto"
        @click="getCampanha()"
      >
        Filtrar
      </button>
    </div>

    <div class="col-12">
      <div class="row">

        <div class="col-sm-12 col-md-3 col-lg-3 mt-4">
          <b-card title="Alcance">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #965ca0">
                  <i class="fas fa-users"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{reach ? reach : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-3 col-lg-3 mt-4">
          <b-card title="Impressões">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #fc8d83">
                  <i class="fas fa-eye"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{impressions ? impressions : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-3 col-lg-3 mt-4">
          <b-card title="Clicks">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #e36b9b">
                  <i class="fas fa-mouse"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{clicks ? clicks : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-3 col-lg-3 mt-4">
          <b-card title="CPC">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #3a5389">
                  <i class="fas fa-calculator"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{cpc ? cpc : '0'}}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-12 mt-4">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Noma campanha</th>
                  <th>Alcance</th>
                  <th>Impressões</th>
                  <th>Clicks</th>
                  <th>CPC</th>
                  <th>CTR</th>
                  <th>Resultado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in campanhas" :key="i">
                  <td>{{item.campaign_name}}</td>
                  <td>{{item.reach}}</td>
                  <td>{{item.impressions}}</td>
                  <td>{{item.clicks}}</td>
                  <td>{{item.cpc}}</td>
                  <td>{{item.ctr}}</td>
                  <td>{{ getFirstReplyValue(item.actions) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import UserTypes from '@/enums/UserTypes';
import NamePermission from '@/enums/Clerk/NamePermission';
import TypePermission from '@/enums/Clerk/TypePermission';

export default {
  name: 'ReportFacebookAds',
  mixins: [makeToast],

  components: {
    PageTitle
  },

  data() {
    return {
      reach: null,
      cpc: null,
      clicks: null,
      impressions: null,
      dados: [],
      campanhas: [],
      data: {
        dateStart: '',
        dateEnd: ''
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.get();
  },

  methods: {
    get() {
      let id = 4427;
      if(this.userTypeId() != 4427) {
        id = 3848;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getTokenLojistaFacebookAds', id)
        .then((response) => {
          this.dados = response.data;
        })
        .catch(() => {
          this.makeToast('Ops!', 'Não foi possível buscar o token!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    getCampanha() {
      if(this.data.dateStart == '' || this.data.dateEnd == '') {
        this.makeToast('Ops!', 'Informe as datas para buscar os dados das campanhas!', 'danger');
        return;
      }

      const url = 'https://graph.facebook.com/v19.0/act_';
      const path = "/insights?level=adset&fields=campaign_name,adset_name,reach,impressions,clicks,cpc,ctr,actions";
      const shopkeeper = `&filtering=[{'field':'campaign.name','operator':'CONTAIN','value':'${this.userTypeId()}'}]`;
      const token = "&access_token="+this.dados.fb_exchange_token;
      const time = `&time_range={'since':'${this.data.dateStart}','until':'${this.data.dateEnd}'}`;

      const urlAll = url+this.dados.client_id+path+shopkeeper+token+time;
      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getFacebookAds', urlAll)
        .then((response) => {
          this.campanhas = response.data.data;

          const total = {
            reach: 0,
            cpc: 0,
            clicks: 0,
            impressions: 0
          };

          this.campanhas.forEach(campanha => {
            total.reach += parseFloat(campanha.reach);
            total.clicks += parseInt(campanha.clicks);
            total.impressions += parseInt(campanha.impressions);
          });

          total.cpc = total.reach / total.clicks;
          total.cpc = parseFloat(total.cpc.toFixed(5));

          this.reach = total.reach;
          this.cpc = total.cpc;
          this.clicks = total.clicks;
          this.impressions = total.impressions;
        })
        .catch(() => {
          this.makeToast('Ops!', 'Não foi possível buscar as campanhas!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    getFirstReplyValue(actions) {
      const result = actions.find(action => action.action_type === 'onsite_conversion.messaging_conversation_started_7d');
      return result ? result.value : 'N/A';
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.SORTEIO);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    },
  },
}
</script>

<style scoped>
.btn-ads {
  width: 50px;
  height: 50px;
  border-radius: 40px;
  border: none;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive table {
  min-width: 600px;
}
@media (min-width: 768px) {
.format-width {
  margin-right: 10px;
}
}
</style>

